module.exports = __webpack_public_path__ + "static/media/afee.2815ef84.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SkywireLanding/images/afee.png
// module id = 1155
// module chunks = 0